"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z50: "#FFFBF7",
  z100: "#FDF5E9",
  z200: "#F5D7A7",
  z300: "#E4B96E",
  z400: "#D1A44D",
  z500: "#B48535",
  z600: "#9F6E1A",
  z700: "#80540F",
  z800: "#68440F",
  z900: "#492E06"
};